/* OREN — Welle 8: Growth features (Popup, Recently Viewed, Exit Intent) */
(function(){

  const KEYS = {
    popup_seen: 'oren_popup_seen',
    popup_dismissed_at: 'oren_popup_dismissed_at',
    recently_viewed: 'oren_recently_viewed',
    exit_shown: 'oren_exit_shown'
  };

  function getJSON(key, fallback){
    try{ const v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; }
    catch(e){ return fallback; }
  }
  function setJSON(key, val){
    try{ localStorage.setItem(key, JSON.stringify(val)); }catch(e){}
  }

  /* ============================================
     NEWSLETTER POPUP
     Shows after 30s, or on exit intent, on first session.
     ============================================ */
  function setupNewsletterPopup(){
    if(localStorage.getItem(KEYS.popup_seen) === '1') return;
    /* Skip on certain pages */
    if(document.body.classList.contains('template-cart') ||
       document.body.classList.contains('template-checkout') ||
       document.body.classList.contains('template-customers') ||
       document.body.classList.contains('template-search') ||
       document.body.classList.contains('template-404')) return;

    /* Skip if dismissed in last 7 days */
    const dismissed = localStorage.getItem(KEYS.popup_dismissed_at);
    if(dismissed){
      const elapsed = Date.now() - parseInt(dismissed);
      if(elapsed < 7 * 24 * 60 * 60 * 1000) return;
    }

    let shown = false;

    function show(){
      if(shown) return;
      shown = true;
      injectPopup();
    }

    /* Timer: 30s */
    setTimeout(show, 30000);

    /* Exit intent: mouse leaves top of viewport */
    let exitArmed = false;
    setTimeout(function(){ exitArmed = true; }, 10000);
    document.addEventListener('mouseleave', function(e){
      if(!exitArmed) return;
      if(e.clientY < 5) show();
    });

    /* Scroll past 60% of page */
    let scrollTriggered = false;
    window.addEventListener('scroll', function(){
      if(scrollTriggered) return;
      const scrolled = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
      if(scrolled > 0.6){
        scrollTriggered = true;
        setTimeout(show, 2000);
      }
    }, { passive: true });
  }

  function injectPopup(){
    const backdrop = document.createElement('div');
    backdrop.className = 'oren-popup-backdrop';

    const popup = document.createElement('div');
    popup.className = 'oren-popup';
    popup.innerHTML =
      '<button class="oren-popup-close" aria-label="Close" data-cursor="Close">✕</button>'+
      '<div class="oren-popup-label">Before you go</div>'+
      '<h2>A small <span class="it">note,</span><br>before each delivery.</h2>'+
      '<p>A short letter from the studio when a new Fragment lands. <em>Two or three a year.</em> No marketing, no countdowns, no sales.</p>'+
      '<form action="/contact#newsletter" method="post" enctype="multipart/form-data" accept-charset="UTF-8" id="orenPopupForm">'+
      '<input type="hidden" name="form_type" value="customer">'+
      '<input type="hidden" name="utf8" value="✓">'+
      '<input type="hidden" name="contact[tags]" value="newsletter">'+
      '<input type="email" name="contact[email]" placeholder="your-email@example.com" required autocomplete="email" data-cursor="Type">'+
      '<button type="submit" data-cursor="Subscribe">Subscribe to deliveries →</button>'+
      '</form>'+
      '<div class="oren-popup-meta">Unsubscribe any time. Your email stays in Berlin.</div>';

    document.body.appendChild(backdrop);
    document.body.appendChild(popup);

    function close(){
      backdrop.classList.remove('visible');
      popup.classList.remove('visible');
      localStorage.setItem(KEYS.popup_dismissed_at, String(Date.now()));
      setTimeout(function(){
        backdrop.remove();
        popup.remove();
      }, 600);
    }

    popup.querySelector('.oren-popup-close').addEventListener('click', close);
    backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function escClose(e){
      if(e.key === 'Escape'){
        close();
        document.removeEventListener('keydown', escClose);
      }
    });

    /* On submit success, mark as seen permanently */
    popup.querySelector('form').addEventListener('submit', function(){
      localStorage.setItem(KEYS.popup_seen, '1');
    });

    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        backdrop.classList.add('visible');
        popup.classList.add('visible');
      });
    });
  }

  /* ============================================
     RECENTLY VIEWED — track product views, render below product page
     ============================================ */
  function trackProductView(){
    if(!document.body.classList.contains('template-product')) return;
    /* Read product info from product schema or DOM */
    const productScript = document.querySelector('script[type="application/ld+json"]');
    if(!productScript) return;
    let product;
    try{
      /* Find the Product JSON-LD */
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(function(s){
        try{
          const data = JSON.parse(s.textContent);
          if(data['@type'] === 'Product') product = data;
        }catch(e){}
      });
    }catch(e){ return; }
    if(!product) return;

    const recent = getJSON(KEYS.recently_viewed, []);
    /* Read product URL from page */
    const url = location.pathname;
    const filtered = recent.filter(function(r){ return r.url !== url; });
    filtered.unshift({
      url: url,
      title: product.name || document.title,
      image: (product.image && product.image[0]) || '',
      price: (product.offers && product.offers.price) ? product.offers.price : '',
      currency: (product.offers && product.offers.priceCurrency) ? product.offers.priceCurrency : 'EUR',
      code: product.productID || '',
      ts: Date.now()
    });
    setJSON(KEYS.recently_viewed, filtered.slice(0, 8));
  }

  function renderRecentlyViewed(){
    const container = document.querySelector('[data-recently-viewed]');
    if(!container) return;
    const recent = getJSON(KEYS.recently_viewed, []);
    /* Exclude current page */
    const filtered = recent.filter(function(r){ return r.url !== location.pathname; });
    if(filtered.length === 0){ container.style.display = 'none'; return; }

    const grid = container.querySelector('.oren-recently-grid');
    grid.innerHTML = filtered.slice(0, 4).map(function(r){
      const priceFormatted = r.price ? formatPrice(r.price, r.currency) : '';
      const codeShort = r.code || '';
      return '<a href="' + r.url + '" class="oren-recently-item" data-cursor="View Fragment">'+
        '<div class="img">' + (r.image ? '<img src="' + r.image + '" alt="' + escape(r.title) + '" loading="lazy">' : '') + '</div>'+
        '<div class="meta"><span class="code">' + escape(codeShort) + '</span><span class="price">' + priceFormatted + '</span></div>'+
        '<div class="title">' + escape(r.title) + '</div>'+
      '</a>';
    }).join('');
  }

  function formatPrice(price, currency){
    try{
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency || 'EUR', maximumFractionDigits: 0 }).format(price);
    }catch(e){
      return (currency || 'EUR') + ' ' + price;
    }
  }

  function escape(s){
    return String(s).replace(/[&<>"\']/g, function(c){
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;','\'':'&#39;' }[c];
    });
  }

  /* ============================================
     EXIT INTENT — small bottom-left banner when user moves to leave
     ============================================ */
  function setupExitIntent(){
    if(sessionStorage.getItem(KEYS.exit_shown) === '1') return;
    if(document.body.classList.contains('template-cart') ||
       document.body.classList.contains('template-checkout') ||
       document.body.classList.contains('template-customers')) return;

    let armed = false;
    setTimeout(function(){ armed = true; }, 15000); /* Wait 15s before arming */

    document.addEventListener('mouseleave', function(e){
      if(!armed) return;
      if(e.clientY < 5){
        showExitBanner();
        armed = false;
      }
    });
  }

  function showExitBanner(){
    if(sessionStorage.getItem(KEYS.exit_shown) === '1') return;
    sessionStorage.setItem(KEYS.exit_shown, '1');

    const banner = document.createElement('div');
    banner.className = 'oren-exit-banner';
    banner.innerHTML =
      '<button class="close" aria-label="Close">✕</button>'+
      '<div class="label">Before you go</div>'+
      '<div class="text">The studio sends a <em>short note</em> when each Fragment lands. Two or three a year.</div>'+
      '<div class="actions">'+
        '<a href="#newsletter" class="btn" data-cursor="Subscribe">Subscribe →</a>'+
      '</div>';
    document.body.appendChild(banner);

    banner.querySelector('.close').addEventListener('click', function(){
      banner.classList.remove('visible');
      setTimeout(function(){ banner.remove(); }, 600);
    });
    banner.querySelector('.btn').addEventListener('click', function(){
      banner.classList.remove('visible');
      const nl = document.querySelector('#newsletter, .newsletter, form[action*="newsletter"]');
      if(nl){
        setTimeout(function(){
          nl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 300);
      }
      setTimeout(function(){ banner.remove(); }, 600);
    });

    requestAnimationFrame(function(){
      requestAnimationFrame(function(){ banner.classList.add('visible'); });
    });

    /* Auto-hide after 12s */
    setTimeout(function(){
      if(banner.parentNode){
        banner.classList.remove('visible');
        setTimeout(function(){ if(banner.parentNode) banner.remove(); }, 600);
      }
    }, 12000);
  }

  /* ============================================
     INIT
     ============================================ */
  function init(){
    trackProductView();
    renderRecentlyViewed();
    setupNewsletterPopup();
    setupExitIntent();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  }else{
    init();
  }
})();
